"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entities_1 = require("./entities");
exports.getOsmosysResourceEndpoint = (obj) => {
    var _a, _b;
    switch (obj.constructor) {
        case entities_1.AccessKey:
            obj = obj;
            return `/integrations/keys/${obj.id}`;
        case entities_1.ActiveCampaign:
            obj = obj;
            return `/integrations/${obj.id}`;
        case entities_1.Ad:
            obj = obj;
            return `/ads/${obj.id}`;
        case entities_1.AppSettings:
            obj = obj;
            return '/admin/settings';
        case entities_1.CampaignMonitor:
            obj = obj;
            return `/integrations/${obj.id}`;
        case entities_1.ContentConversion:
            obj = obj;
            return `/integrations/${obj.contentSystemId}/conversions/${obj.id}`;
        case entities_1.ContentConversionStep:
            obj = obj;
            return `/integrations/${(_a = obj.contentConversion) === null || _a === void 0 ? void 0 : _a.contentSystemId}/conversions/${obj.contentConversionId}`;
        case entities_1.ContentFeed:
            obj = obj;
            return `/integrations/${obj.contentSystemId}/feeds/${obj.id}`;
        case entities_1.ContentMapping:
            obj = obj;
            return `/integrations/${obj.contentSystemId}/mappings/${obj.id}`;
        case entities_1.ContentSystem:
            obj = obj;
            return `/integrations/${obj.id}`;
        case entities_1.Context:
            obj = obj;
            return `/contexts/${obj.id}`;
        case entities_1.Email:
            obj = obj;
            return `/emails/${obj.emailNumber}`;
        case entities_1.EmailBase:
            obj = obj;
            return `/emails/${obj.id}`;
        case entities_1.EmailCampaign:
            obj = obj;
            return `/campaigns/${obj.id}`;
        case entities_1.EmailList:
            obj = obj;
            return `/lists/${obj.id}`;
        case entities_1.EmailSegment:
            obj = obj;
            return `/segments/${obj.id}`;
        case entities_1.EmailTemplate:
            obj = obj;
            return `/templates/${obj.id}`;
        case entities_1.EmailTemplateBlock:
            obj = obj;
            return `/templates/blocks/${obj.id}`;
        case entities_1.EmailTemplateVersion:
            obj = obj;
            return `/templates/${obj.templateId}/versions/${obj.id}`;
        case entities_1.EmailTemplateVersionDeployment:
            obj = obj;
            return `/templates/${obj.templateId}/deployments`;
        case entities_1.HostedFile:
            obj = obj;
            return `/files/${obj.id}`;
        case entities_1.Integration:
            obj = obj;
            return `/integrations/${obj.id}`;
        case entities_1.Mailchimp:
            obj = obj;
            return `/integrations/${obj.id}`;
        case entities_1.Mailjet:
            obj = obj;
            return `/integrations/${obj.id}`;
        case entities_1.Organization:
            obj = obj;
            return `/admin/organizations/${obj.id}`;
        case entities_1.OsmosysMessage:
            obj = obj;
            return `/messages/${obj.id}`;
        case entities_1.Sailthru:
            obj = obj;
            return `/integrations/${obj.id}`;
        case entities_1.Salesforce:
            obj = obj;
            return `/integrations/${obj.id}`;
        case entities_1.Session:
            obj = obj;
            return `/sessions/${obj.id}`;
        case entities_1.TransactionalEmail:
            obj = obj;
            return `/emails/${obj.id}`;
        case entities_1.User:
            obj = obj;
            return `/admin/users/${obj.id}`;
        case entities_1.UserInvite:
            obj = obj;
            return `/admin/users/${obj.userId}`;
        case entities_1.Workflow:
            obj = obj;
            return `/workflows/${obj.id}`;
        case entities_1.WorkflowRun:
            obj = obj;
            return `/workflows/${obj.workflowId}/runs/${obj.id}`;
        case entities_1.WorkflowRunAction:
            obj = obj;
            return `/workflows/${(_b = obj.workflowRun) === null || _b === void 0 ? void 0 : _b.workflowId}/runs/${obj.workflowRunId}`;
        case entities_1.Workspace:
            obj = obj;
            return `/admin/workspaces/${obj.id}`;
        case entities_1.WorkspaceMembership:
            obj = obj;
            return `/admin/memberships/${obj.id}`;
        default:
            return '/';
    }
};
//# sourceMappingURL=getOsmosysResourceEndpoint.js.map